export default "__VITE_ASSET__259b9548__"